import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as h } from "../../../../IconBase-CxZyIWw2.js";
const l = t((a, e) => /* @__PURE__ */ s.jsx(
  h,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3713",
              width: 12,
              height: 16,
              x: 2,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M12.74 0H3.2C2.54 0 2 .54 2 1.2v13.6c0 .66.54 1.2 1.2 1.2h9.54c.66 0 1.2-.54 1.2-1.2V1.2c0-.66-.54-1.2-1.2-1.2m-.3 14.5H3.5v-13h8.94z"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M5.22 11.15h5.5a.749.749 0 1 0 0-1.5h-5.5a.749.749 0 1 0 0 1.5M5.22 13.56h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.5a.749.749 0 1 0 0 1.5M5.43 6.46h1.79v1.79a.749.749 0 1 0 1.5 0V6.46h1.79a.749.749 0 1 0 0-1.5H8.72v-1.8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.79H5.43a.755.755 0 0 0 0 1.51"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3713)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
l.displayName = "AgencyTreatmentPlanIcon";
export {
  l as AgencyTreatmentPlanIcon,
  l as default
};
//# sourceMappingURL=index.js.map
